export default __webpack_public_path__ + "static/threegable_client-ce4a32ff5b55fbdfcbeb897c571e83e8.png";